import api from '../../services/api';

/*
 * The operator API (`/operators/`). Only this API knows the operator's reach
 * — the warehouses assigned to them, or their admin's when none is — so the
 * operator workspace never calls the admin/seller WMS endpoints.
 *
 * Every call reports its own lost answer, in the screen's band, with a retry
 * that reuses the idempotency key (see `services/api`).
 */
export const OPERATOR_REQUEST_CONFIG = { reportsNoAnswer: true };

/**
 * @param {number|string} warehouseId
 * @param {string} [rest] - e.g. `'receipts/12/count/'`.
 */
export const warehousePath = (warehouseId, rest = '') => `operators/warehouses/${warehouseId}/${rest}`;

/** Who the operator is, and what each of their warehouses lets them do, with queue sizes. */
export const getOperatorWorkspaceRequest = () =>
  api.get('operators/me/', { ...OPERATOR_REQUEST_CONFIG, params: { counts: 1 } });

/**
 * What a code is in a warehouse: a slot, a product, a receipt, a supply.
 *
 * @param {number|string} warehouseId
 * @param {string} code
 * @param {string[]} expect
 */
export const scanCodeRequest = (warehouseId, code, expect) =>
  api.get(warehousePath(warehouseId, 'scan/'), {
    ...OPERATOR_REQUEST_CONFIG,
    params: { code, expect: expect.join(',') },
  });

/**
 * What there is of a product in a warehouse and where, or what a slot holds.
 *
 * @param {number|string} warehouseId
 * @param {{product_id?: number, slot_id?: number, code?: string}} params - One of them.
 */
export const getStockRequest = (warehouseId, params) =>
  api.get(warehousePath(warehouseId, 'stock/'), { ...OPERATOR_REQUEST_CONFIG, params });
